

const UtilsLocalizedSorting = (lang, array) => {

var arraySorted = [];
  switch (lang) {
    case "ar":
     arraySorted =  array.sort(function(a, b) {
  if(a.name_ar < b.name_ar) return -1;
  if(a.name_ar > b.name_ar) return 1;
  return 0});
      break;
    case "en":
      arraySorted = array.sort(function(a, b) {
  if(a.name.toLowerCase() < b.name.toLowerCase()) return -1;
  if(a.name.toLowerCase() > b.name.toLowerCase()) return 1;
  return 0;
 });
      break;
    case "fr":
        arraySorted = array.sort(function(a, b) {
  return a.name_fr.localeCompare(b.name_fr, "fr", { sensitivity: "base" });
 });
      break;
    case "ru":
      arraySorted = array.sort(function(a, b) {
  if(a.name_ru < b.name_ru) return -1;
  if(a.name_ru > b.name_ru) return 1;
  return 0;
   });
      break;
    case "zh":
           arraySorted = array.sort(function(a, b) {
  if(a.name_zh < b.name_zh) return -1;
  if(a.name_zh > b.name_zh) return 1;
  return 0;
 });;
      break;
       case "es":
         arraySorted = array.sort(function(a, b) {
  return a.name_es.localeCompare(b.name_es, "es", { sensitivity: "base" });
 });
      break;
    default:
        arraySorted = array.sort(function(a, b) {
  if(a.name.toLowerCase() < b.name.toLowerCase()) return -1;
  if(a.name.toLowerCase() > b.name.toLowerCase()) return 1;
  return 0;
 });
  }
 return arraySorted;
}
export default UtilsLocalizedSorting;